<template>
  <div v-if="selectedSite && selectedSite.id">
    <p class="noYPadding text">
      {{ $t(`copySite.step1.select`) }}
    </p>
    <Tree
      :id="selectedSite.id"
      :nodeItem="tree"
      :name="selectedSite.name"
      nodeType="Site"
      viewFrom="CopySite"
      :site="selectedSite"
      :showAll="false"
      :isSelectMode="true"
      :nodes="tree.children"
      @checkBoxValueChanged="checkBoxValueChanged"
      @nodeItemChanged="nodeItemChanged"
    />
  </div>
  <div
    v-else
    class="text-center"
  >
    <p class="noYPadding text">
      {{ $t(`copySite.selectSite`) }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import nodeMixim from '@/mixins/NodeMixim';

export default {
    name: 'TreeViewSelection',
    mixins: [
        nodeMixim,
    ],
    data() {
        return {
            data: {
                selectedTreeNodes: [],
            },
            tree: {},
        };
    },
    computed: {
        ...mapGetters([
            'selectedSite',
        ]),
    },
    watch: {
        selectedSite: {
            async handler() {
                if (this.selectedSite) {
                    await this.getTree(this.selectedSite.id);
                }
            },
            deep: true,
        },
    },
    async created() {
        if (this.selectedSite) {
            await this.getTree(this.selectedSite.id);
        }
    },
    methods: {
        async getTree(siteId) {
            this.loading = true;
            const { data } = await this.$rq.getSiteTree(siteId);
            // create root object for the tree
            this.tree = {
                children: [...this.mapChildren(data.tree)],
                active: true,
                ref: this.selectedSite.id,
                showChildren: false,
                type: {},
            };
            this.loading = false;
        },
        findSelectedNode(node, nodeItem, selectedParentNode) {
            if (node.nodeType !== 'Component' && node.children) {
                for (let index = 0; index < node.children.length; index += 1) {
                    const n = node.children[index];
                    // node(network) is node in root level
                    if (n.ref === nodeItem.parentNode) {
                        // if the selected item is a component the parent network is automatically selected.
                        if (nodeItem.nodeType === 'Component') {
                            n.isSelected = n.children && n.children.some(c => c.isSelected);
                            // eslint-disable-next-line no-param-reassign
                            selectedParentNode = n;
                        }
                    }

                    // node(network) is in root level
                    if ((n.nodeType === 'Component') && (n.parentNode === node.ref)) {
                        // eslint-disable-next-line no-param-reassign
                        node.isSelected = node.children && node.children.some(c => c.isSelected);
                        // eslint-disable-next-line no-param-reassign
                        selectedParentNode = node;
                    }

                    if (n.children) {
                        // eslint-disable-next-line no-param-reassign
                        selectedParentNode = this.findSelectedNode(n, nodeItem, selectedParentNode);
                    }
                }
            }
            return selectedParentNode;
        },
        checkBoxValueChanged(nodeItem) {
            if (nodeItem.parentNode) {
                const treeCopy = { ...this.tree };
                // find the parent node
                let selectedParentNode;
                treeCopy.children.forEach(node => {
                    if (node.ref === nodeItem.parentNode) {
                        selectedParentNode = { ...node };
                    }
                    selectedParentNode = this.findSelectedNode(node, nodeItem, selectedParentNode);
                });
                // if we did not find it, it's maybe because it the first item in the tree.
                // so we assign selectedParentNode to the root.
                if (!selectedParentNode) {
                    selectedParentNode = this.tree;
                }

                // edit parent children
                const childFromParentIndex = selectedParentNode.children.findIndex(node => node.ref === nodeItem.ref);
                selectedParentNode.children[childFromParentIndex] = { ...nodeItem };

                // re-asign child node to parent
                const childFromTreeIndex = selectedParentNode.children.findIndex(node => node.ref === nodeItem.ref);
                if (childFromTreeIndex !== -1) {
                    selectedParentNode.children[childFromTreeIndex] = { ...nodeItem };
                }
                // re-asign parent node to the tree (trigger change)
                const children = this.replaceNode(treeCopy, selectedParentNode);
                this.tree = { ...treeCopy, showChildren: true, children };
            } else {
                this.tree = { ...this.tree, showChildren: true, children: nodeItem.children };
            }
            this.$emit('sendData', { selectedTreeNodes: this.tree });
        },
        nodeItemChanged(value) {
            const children = this.replaceNode(this.tree, value);
            this.tree = { ...this.tree, children, showChildren: true };
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.text {
    font-size: 18px;
}
</style>
